import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaQuadrosAtivosADMRHInicio: [],
    buscaQuadrosAtivosADMRHErro: ['erro'],
    buscaQuadrosAtivosADMRHSucesso: ['quadrosAtivosADMRH'],
    limpar: [],
    setQuadrosAtivosADMRHEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaQuadrosAtivosADMRH = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaQuadrosAtivosADMRHInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarQuadrosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaQuadrosAtivosADMRHSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaQuadrosAtivosADMRHErro(error)))
    }
}

const buscaQuadrosAtivosADMRHInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaQuadrosAtivosADMRHErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaQuadrosAtivosADMRHSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.quadrosAtivosADMRH.resultado,
        dataSincronizacaoDados: action.quadrosAtivosADMRH.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setQuadrosAtivosADMRHEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_QUADROS_ATIVOS_ADMRH_INICIO]: buscaQuadrosAtivosADMRHInicio,
    [Types.BUSCA_QUADROS_ATIVOS_ADMRH_ERRO]: buscaQuadrosAtivosADMRHErro,
    [Types.BUSCA_QUADROS_ATIVOS_ADMRH_SUCESSO]: buscaQuadrosAtivosADMRHSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_QUADROS_ATIVOS_ADMRH_ESTADO_DT]: setQuadrosAtivosADMRHEstadoDT,
})
